






















































import { computed, defineComponent, SetupContext, Ref, ref } from "@vue/composition-api";

import { writeToClipboard } from "../../service/clipboard";
import { actions } from "../store";

import Modal from "./Modal.vue";
import ReadOnlyInput from "./ReadOnlyInput.vue";
import Button from "./Button.vue";

interface Props {
    isOpen: boolean;
    privateKey: string;
    publicKey: string;
}

export default defineComponent({
    name: "ModalViewKeys",
    components: {
        Modal,
        ReadOnlyInput,
        Button
    },
    model: {
        prop: "isOpen",
        event: "change"
    },
    props: {
        isOpen: Boolean,
        privateKey: String,
        publicKey: String
    },
    setup(props: Props, context: SetupContext) {
        const publicInput: Ref<HTMLElement | null> = ref(null);
        const publicCompKey = ref(0);
        const privateInput: Ref<HTMLElement | null> = ref(null);
        const privateCompKey = ref(0);

        const hasPrivateKey = computed(() => props.privateKey !== "" && props.privateKey != null);
        const hasPublicKey = computed(() => props.publicKey !== "" && props.publicKey != null);

        const title = computed(() => {
            if (hasPrivateKey.value && hasPublicKey.value) {
                return context.root.$t("modalViewKeys.title");
            } else if (hasPublicKey.value) {
                return context.root.$t("modalViewKeys.publicKey");
            } else if (hasPrivateKey.value) {
                return context.root.$t("modalViewKeys.privateKey");
            }
            return "";
        });

        async function handleCopyPublicKey(): Promise<void> {
            publicCompKey.value += 1;
            context.root.$nextTick(() => {
                if (publicInput.value != null) {
                    writeToClipboard(publicInput.value);

                    actions.alert({
                        level: "info",
                        message: context.root
                            .$t("modalViewKeys.copiedPublic")
                            .toString()
                    });
                }
            });
        }

        async function handleCopyPrivateKey(): Promise<void> {
            privateCompKey.value += 1;
            context.root.$nextTick(() => {
                if (privateInput.value != null) {
                    writeToClipboard(privateInput.value);

                    actions.alert({
                        level: "info",
                        message: context.root
                            .$t("modalViewKeys.copiedPrivate")
                            .toString()
                    });
                }
            });
        }

        return {
            publicInput,
            publicCompKey,
            privateInput,
            privateCompKey,
            title,
            hasPrivateKey,
            hasPublicKey,
            handleCopyPublicKey,
            handleCopyPrivateKey
        };
    }
});
